import { Component } from 'preact';
import style from './style';
import Image from '@components/image';
import Input from '@components/input';
import Button from '@components/button';
import Text from '@components/translate';
import I18n from '@i18n';
import { countryCodes } from './countryCodes';

export class CountryCodeSelectorDisplay extends Component {
  render(
    { onChange, contact_info, autocomplete, onAutoComplete },
    { showAll },
    context
  ) {
    return (
      <div class={style.countryCodeSelectorDisplay}>
        <div class={style.smallPadding}>
          <Input
            size="full"
            placeholder={I18n.t('Search')}
            value={autocomplete}
            onInput={onAutoComplete}
          />
        </div>
        <div class={style.countryCodeSelectorWrapper}>
          <ul class={style.countryCodeList}>
            {Object.keys(countryCodes)
              .filter(
                country_code =>
                  (!autocomplete && country_code === 'fi') ||
                  (!autocomplete && country_code === 'ee') ||
                  (!autocomplete && showAll) ||
                  (autocomplete.split(' ').join('') &&
                    `${country_code.split(' ').join('')}${
                      countryCodes[country_code]
                    }`.indexOf(
                      autocomplete.split(' ').join('').toLowerCase()
                    ) !== -1)
              )
              .map(country_code => (
                <li class={style.countryCodeListItem}>
                  <div class={style.countryCodeFlag}>
                    <Button
                      class={style.countryCodeName}
                      onClick={() => {
                        onChange({
                          ...contact_info,
                          country_code: country_code.toUpperCase(),
                        });
                        context.closePopOver();
                      }}
                    >
                      <span class={style.countryCodeFlagWrapper}>
                        <Image
                          src={`https://cdn.rawgit.com/hjnilsson/country-flags/master/svg/${country_code}.svg`}
                          alt={countryCodes[country_code]}
                          class={style.countryCodeFlagImage}
                        />
                      </span>
                    </Button>
                  </div>
                  <Button
                    class={style.countryCodeName}
                    onClick={() => {
                      onChange({
                        ...contact_info,
                        country_code: country_code.toUpperCase(),
                      });
                      context.closePopOver();
                    }}
                  >
                    <span>
                      {countryCodes[country_code]} ({country_code.toUpperCase()}
                      )
                    </span>
                  </Button>
                </li>
              ))}
            {!showAll ? (
              <li class={style.countryCodeListItem}>
                <div class={style.showAll}>
                  <Button
                    class={style.countryCodeName}
                    onClick={() => this.setState({ showAll: true })}
                  >
                    <Text>{I18n.t("Show all")}</Text>
                  </Button>
                </div>
              </li>
            ) : null}
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./routes/book/CountryCodeSelectorDisplay.js